// Write your code here
import './index.css'

const SuggestionItem = props => {
  const {item, changeItem} = props
  const {suggestion} = item
  const showResult = () => {
    changeItem(suggestion)
  }
  return (
    <li className="list-item">
      <p>{suggestion}</p>
      <img
        onClick={showResult}
        alt="arrow"
        src="https://assets.ccbp.in/frontend/react-js/diagonal-arrow-left-up.png"
        className="icon"
      />
    </li>
  )
}
export default SuggestionItem
